module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\n// The fragment shader used to render the background of the scene\r\n// Modify this to make your background more interesting\r\n\r\nout vec4 out_Col;\r\n\r\nvoid main() {\r\n  out_Col = vec4(164.0 / 255.0, 233.0 / 255.0, 1.0, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-frag.glsl
// module id = 72
// module chunks = 0